import { render, staticRenderFns } from "./IconArrowRightOutline.vue?vue&type=template&id=a2b151b8"
import script from "./IconArrowRightOutline.vue?vue&type=script&lang=js"
export * from "./IconArrowRightOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports